// form-field.component.ts
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-form-field',
  template: `
    <div>
      <h6>{{ field.label }} <span *ngIf="field.required" class="text-danger">*</span></h6>
      <p-dropdown 
        *ngIf="field.name === 'direction' || field.name === 'structure'"
        class="custom-dropdown"
        [(ngModel)]="value"
        [options]="field.name === 'direction' ? listDR : listStructure"
        (onClear)="clearItem(field.name)"
        (onChange)="changeItem($event, field.name)"
        placeholder="Selectionnez une {{ field.label.toLowerCase() }}"
        emptyFilterMessage="Aucune {{ field.label.toLowerCase() }} trouvée"
        optionLabel="code"
        optionValue="id"
        [filter]="true"
        filterBy="code,value.code"
        [showClear]="true">
      </p-dropdown>
      <input *ngIf="field.name === 'matricule' || field.name === 'nom_prenoms'"
        class="input__field"
        type="text"
        [(ngModel)]="value"
        (ngModelChange)="changeItem($event, field.name)"
        placeholder="{{ field.label }}"
        pInputText />
    </div>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FormFieldComponent),
    multi: true
  }]
})
export class FormFieldComponent implements ControlValueAccessor {
  @Input() field: any;
  @Input() listDR: any[];
  @Input() listStructure: any[];

  @Output() onChangeItem = new EventEmitter<any>();
  @Output() onClearItem = new EventEmitter<string>();

  changeItem(event: any, field: string) {
    this.onChangeItem.emit({ field, value: event });
    this.onChange(event);
  }

  clearItem(field: string) {
    this.value = null;
    this.onClearItem.emit(field);
    this.onChange(null);
  }

  value: any;
  onTouched: () => void;
  onChange: (value: any) => void;

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if you need to handle the disabled state
  }
}
